import React from 'react';
import { ChevronRightIcon, ChevronLeftIcon } from '@ag1/ui';
import styles from './Carousel.module.scss';

type CarouselControlsProps = {
  handleNextSlide: () => void;
  handlePreviousSlide: () => void;
  showNextButton: boolean;
  showPreviousButton: boolean;
};

export const CarouselControls = ({
  handleNextSlide,
  handlePreviousSlide,
  showNextButton,
  showPreviousButton
}: CarouselControlsProps) => (
  <div className={styles.controls} aria-label="Carousel Controls" role="group">
    {showPreviousButton && (
      <button
        aria-label="Previous Slide"
        type="button"
        onClick={handlePreviousSlide}
        className={styles.previous}>
        <ChevronLeftIcon />
      </button>
    )}
    {showNextButton && (
      <button
        aria-label="Next Slide"
        type="button"
        onClick={handleNextSlide}
        className={styles.next}>
        <ChevronRightIcon />
      </button>
    )}
  </div>
);
